module.exports = __webpack_public_path__ + "assets/img/examnopass.91401a73.png";